import { createFileRoute } from "@tanstack/react-router";
import { AutomapPage } from "@/features/automap/AutomapPage";

export const Route = createFileRoute("/_app/automations/map")({
  component: () => <AutomapPage />,
});
